import React, { useRef, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../util/api";
import swal from "sweetalert";

import Footer from "../common/Footer";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";


import Photo from "../assets/img/profile-img.jpg";

const ViewCustomer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let customer = location.state.customer;

    // useEffect(() => {
        
    // }, []);


  async function approveCustomer() {
    const token = localStorage.getItem("token");
    try {
      const res = await api.get(`/admin/approve-customer/${customer.user_id}`, {
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      if (res.data.success) {
        swal("Success!", res.data.message, "success", {
            button: false,
            timer: 1500,
          });
      }
    } catch (err) {
      swal("Failed!", "error", {
        button: false,
        timer: 1500
      });
    }
  }

  return (
    <div>
            <Header/>
            <Sidebar/>
            <main id="main" className="main">
              <div className="pagetitle">
                <h1>Customers</h1>
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item"><a href="/customers">Customers</a></li>
                    <li className="breadcrumb-item active">{customer.firstname} {customer.lastname}</li>
                  </ol>
                </nav>
              </div>{/* End Page Title */}
              
                <section className="section profile">
                    <div className="row">
                    <div className="col-xl-4">
                        <div className="card">
                        <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                            <img src={Photo} alt="Profile" className="rounded-circle" />
                            <h2>{customer.firstname} {customer.lastname}</h2>
                            <h3>{customer.email}</h3>
                            <div className="social-links mt-2">
                            <a href="#"><i className="bi bi-patch-check" /> {customer.kyc_status}</a>
                            </div>
                        </div>
                        </div>
                        <div class="d-grid gap-2 mt-3">
                            {customer.kyc_status == 'completed' ? 
                            <button class="btn btn-danger mb-4" type="button">Suspend Account</button> : customer.kyc_status == 'pending' ? 
                            <button class="btn btn-success mb-4" type="button"  data-bs-toggle="modal" data-bs-target="#verification">Approve Account</button> : 
                            <button class="btn btn-primary mb-4" type="button">Re-Activate Account</button>}
                        </div>

                        <div className="modal fade" id="verification" tabIndex={-1}>
                            <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                <h5 className="modal-title">KYC Verification</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                This check costs N50.00 via flutterwave BVN verification API, make sure user provides correct details for proper check.
                                </div>
                                <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="button" data-bs-dismiss="modal" onClick={()=>approveCustomer()} className="btn btn-primary">Proceed</button>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8">
                        <div className="card">
                        <div className="card-body pt-3">
                            {/* Bordered Tabs */}
                            <ul className="nav nav-tabs nav-tabs-bordered">
                            <li className="nav-item">
                                <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#profile-overview">Overview</button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-edit">Edit Profile</button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-bank">Bank Details</button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-settings">Settings</button>
                            </li>
                            <li className="nav-item">
                                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#profile-change-password">Change Password</button>
                            </li>
                            </ul>
                            <div className="tab-content pt-2">
                            <div className="tab-pane fade show active profile-overview" id="profile-overview">
                                <h5 className="card-title">Customer Details</h5>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label ">First Name</div>
                                <div className="col-lg-9 col-md-8">{customer.firstname}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label ">Last Name</div>
                                <div className="col-lg-9 col-md-8">{customer.lastname}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">Email</div>
                                <div className="col-lg-9 col-md-8">{customer.email}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">Telephone</div>
                                <div className="col-lg-9 col-md-8">{customer.phone}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">BVN</div>
                                <div className="col-lg-9 col-md-8">{customer.bvn}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">Date of Birth</div>
                                <div className="col-lg-9 col-md-8">{customer.dob}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">Sex</div>
                                <div className="col-lg-9 col-md-8">{customer.sex}</div>
                                </div>
                                <div className="row">
                                <div className="col-lg-3 col-md-4 label">Quidax ID</div>
                                <div className="col-lg-9 col-md-8">{customer.q_id}</div>
                                </div>

                            </div>
                            <div className="tab-pane fade profile-edit pt-3" id="profile-edit">
                                {/* Profile Edit Form */}
                                <form>
                                <div className="row mb-3">
                                    <label htmlFor="profileImage" className="col-md-4 col-lg-3 col-form-label">Profile Image</label>
                                    <div className="col-md-8 col-lg-9">
                                    <img src="assets/img/profile-img.jpg" alt="Profile" />
                                    <div className="pt-2">
                                        <a href="#" className="btn btn-primary btn-sm" title="Upload new profile image"><i className="bi bi-upload" /></a>
                                        <a href="#" className="btn btn-danger btn-sm" title="Remove my profile image"><i className="bi bi-trash" /></a>
                                    </div>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="fullName" className="col-md-4 col-lg-3 col-form-label">Full Name</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="fullName" type="text" className="form-control" id="fullName" defaultValue="Kevin Anderson" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="company" className="col-md-4 col-lg-3 col-form-label">Company</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="company" type="text" className="form-control" id="company" defaultValue="Lueilwitz, Wisoky and Leuschke" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="Job" className="col-md-4 col-lg-3 col-form-label">Job</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="job" type="text" className="form-control" id="Job" defaultValue="Web Designer" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="Country" className="col-md-4 col-lg-3 col-form-label">Country</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="country" type="text" className="form-control" id="Country" defaultValue="USA" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="Address" className="col-md-4 col-lg-3 col-form-label">Address</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="address" type="text" className="form-control" id="Address" defaultValue="A108 Adam Street, New York, NY 535022" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="Phone" className="col-md-4 col-lg-3 col-form-label">Phone</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="phone" type="text" className="form-control" id="Phone" defaultValue="(436) 486-3538 x29071" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="Email" className="col-md-4 col-lg-3 col-form-label">Email</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="email" type="email" className="form-control" id="Email" defaultValue="k.anderson@example.com" />
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button type="submit" className="btn btn-primary">Save Changes</button>
                                </div>
                                </form>{/* End Profile Edit Form */}
                            </div>
                            <div className="tab-pane fade pt-3" id="profile-bank">
                                {/* Bank Details*/}
                                <h5 className="card-title">Customer Virtual Account</h5>
                                <div className="row mb-3">
                                    <label htmlFor="accName" className="col-md-4 col-lg-3 col-form-label">Account Name</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="accName" type="text" className="form-control" id="accName" defaultValue="Kevin Anderson" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="accNo" className="col-md-4 col-lg-3 col-form-label">Account Number</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="accNo" type="text" className="form-control" id="accNo" defaultValue="0120909822" />
                                    </div>
                                </div>
                                <h5 className="card-title">Customer Bank Details</h5>
                                <form>
                                <div className="row mb-3">
                                    <label htmlFor="bankName" className="col-md-4 col-lg-3 col-form-label">Bank</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="bankName" type="text" className="form-control" id="bankName" defaultValue="GTBank PLC" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="accName" className="col-md-4 col-lg-3 col-form-label">Account Name</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="accName" type="text" className="form-control" id="accName" defaultValue="Kevin Anderson" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="accNo" className="col-md-4 col-lg-3 col-form-label">Account Number</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="accNo" type="text" className="form-control" id="accNo" defaultValue="0120909822" />
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button type="submit" className="btn btn-primary">Update Bank Details</button>
                                </div>
                                </form>
                                {/* End Bank Details*/}
                            </div>
                            <div className="tab-pane fade pt-3" id="profile-settings">
                                {/* Settings Form */}
                                <form>
                                <div className="row mb-3">
                                    <label htmlFor="fullName" className="col-md-4 col-lg-3 col-form-label">Email Notifications</label>
                                    <div className="col-md-8 col-lg-9">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="changesMade" defaultChecked />
                                        <label className="form-check-label" htmlFor="changesMade">
                                        Changes made to your account
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="newProducts" defaultChecked />
                                        <label className="form-check-label" htmlFor="newProducts">
                                        Information on new products and services
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="proOffers" />
                                        <label className="form-check-label" htmlFor="proOffers">
                                        Marketing and promo offers
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" id="securityNotify" defaultChecked disabled />
                                        <label className="form-check-label" htmlFor="securityNotify">
                                        Security alerts
                                        </label>
                                    </div>
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button type="submit" className="btn btn-primary">Save Changes</button>
                                </div>
                                </form>{/* End settings Form */}
                            </div>
                            <div className="tab-pane fade pt-3" id="profile-change-password">
                                {/* Change Password Form */}
                                <form>
                                <div className="row mb-3">
                                    <label htmlFor="currentPassword" className="col-md-4 col-lg-3 col-form-label">Current Password</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="password" type="password" className="form-control" id="currentPassword" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="newPassword" className="col-md-4 col-lg-3 col-form-label">New Password</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="newpassword" type="password" className="form-control" id="newPassword" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="renewPassword" className="col-md-4 col-lg-3 col-form-label">Re-enter New Password</label>
                                    <div className="col-md-8 col-lg-9">
                                    <input name="renewpassword" type="password" className="form-control" id="renewPassword" />
                                    </div>
                                </div>
                                <div className="text-center">
                                    <button type="submit" className="btn btn-primary">Change Password</button>
                                </div>
                                </form>{/* End Change Password Form */}
                            </div>
                            </div>{/* End Bordered Tabs */}
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
            </main>{/* End #main */}
           <Footer/>
            <a href="#" className="back-to-top d-flex align-items-center justify-content-center"><i className="bi bi-arrow-up-short" /></a>
          </div>
      );

}


export default ViewCustomer;